/**
 * House plan: one persistent floating panel anchored to the SVG marker.
 */
import { initAnchorTooltips } from "./anchor-tooltips.js";

function boot() {
  initAnchorTooltips(".house-plan__image-wrapper", {
    tooltipId: "house-plan-tooltip",
    persistent: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
